import {
    GET_EVALUATION_TYPES_FAIL,
    GET_EVALUATION_TYPES_SUCCESS,
    ADD_EVALUATION_TYPE_SUCCESS,
    ADD_EVALUATION_TYPE_FAIL,
    UPDATE_EVALUATION_TYPE_SUCCESS,
    UPDATE_EVALUATION_TYPE_FAIL,
    DELETE_EVALUATION_TYPE_SUCCESS,
    DELETE_EVALUATION_TYPE_FAIL,


} from "./actionTypes";

const INIT_STATE = {
    evaluationTypes: [],
    error: null,
    loading: false,
    lastActionSuccess: false,

};

const evaluationTypeReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des evaluationTypes
        case GET_EVALUATION_TYPES_SUCCESS:
            return {
                ...state,
                evaluationTypes: action.payload, // tableau d'objets evaluation
                loading: false,
                error: null
            };

        case GET_EVALUATION_TYPES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une evaluatione
        case ADD_EVALUATION_TYPE_SUCCESS:
            return {
                ...state,
                evaluationTypes: [action.payload, ...state.evaluationTypes], // ajoute au début du tableau
                error: null,
                lastActionSuccess: true
            };

        case ADD_EVALUATION_TYPE_FAIL:
            return {
                ...state,
                error: action.payload,
                lastActionSuccess: false
            };

        // Mise à jour d'une evaluatione
        case UPDATE_EVALUATION_TYPE_SUCCESS:
            return {
                ...state,
                evaluationTypes: state.evaluationTypes.map(evaluationType =>
                    evaluationType.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet evaluation
                        : evaluation
                ),
                error: null,
                lastActionSuccess: true
            };

        case UPDATE_EVALUATION_TYPE_FAIL:
            return {
                ...state,
                error: action.payload,
                lastActionSuccess: false
            };

        // Suppression d'une evaluatione
        case DELETE_EVALUATION_TYPE_SUCCESS:
            return {
                ...state,
                evaluationTypes: state.evaluationTypes.filter(
                    evaluationType => evaluation.id !== action.payload
                ),
                error: null
            };


        case DELETE_EVALUATION_TYPE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case "RESET_LAST_ACTION_SUCCESS":
            return { 
                ...state, 
                lastActionSuccess: false 
            };

        

        default:
            return state;
    }
};

export default evaluationTypeReducer;
